import { merge } from '../../helper';

import isEmptyObject from '../../general/isEmpty/isEmptyObject';

import exExternal from '../../external';
import * as exElement from '../../utils/element';
import * as exEvent from '../../utils/event';
import * as exTimeout from '../../utils/timeout';

import * as exUtils from './utils';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {
        dataAttributes: false,
        bootstrap: {
            enabled: true,
        },
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // Create element (tooltip)
    const elTooltip = exElement.create({
        merge: defConfig,
        dataset: {
            bsToggle: 'tooltip',
        },
    });
    elements.element = elTooltip;

    // ------------------------------------------------------------------------

    // Settings
    settings(elements, defConfig);

    // ------------------------------------------------------------------------

    // If using bootstrap
    if (defConfig.bootstrap?.enabled === true) {
        // Bootstrap (tooltip)
        const bsTooltip = new exExternal.bootstrap.Tooltip(elements.element, defConfig.bootstrap);
        elements.bs = bsTooltip;
    }

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

function settings(elements: Record<string, any>, config: Record<string, any> = {}): void {
    // If using custom html
    if (config.customHtml === true) {
        if (config.dataAttributes === true) {
            elements.element.dataset.bsHtml = true;
        } else {
            config.bootstrap.html = true;
        }
    }

    // If using custom class
    if (config.customClass != null) {
        if (config.dataAttributes === true) {
            elements.element.dataset.bsCustomClass = config.customClass;
        } else {
            config.bootstrap.customClass = config.customClass;
        }
    }

    // ------------------------------------------------------------------------

    // If using title
    if (config.title != null) {
        if (config.dataAttributes === true) {
            elements.element.dataset.bsTitle = config.title;
        } else {
            config.bootstrap.title = config.title;
        }
    }

    // If using placement
    if (config.placement != null) {
        if (config.dataAttributes === true) {
            elements.element.dataset.bsPlacement = config.placement;
        } else {
            config.bootstrap.placement = config.placement;
        }
    }

    // ------------------------------------------------------------------------

    // If using trigger
    if (config.trigger != null) {
        if (config.dataAttributes === true) {
            elements.element.dataset.bsTrigger = config.trigger;
        } else {
            config.bootstrap.trigger = config.trigger;
        }
    }

    // If using delay
    if (config.delay != null) {
        if (config.dataAttributes === true) {
            elements.element.dataset.bsDelay = config.delay;
        } else {
            config.bootstrap.delay = config.delay;
        }
    }

    // ------------------------------------------------------------------------

    // If using timeout
    if (config.timeout === true || !isEmptyObject(config.timeout)) {
        // Timeout Start
        void exTimeout.start({
            merge: config.timeout,
            time: 2000,
            element: elements.element,
            type: 'tooltipTimeout',
            fnAction: function (): any {
                exUtils.hide(elements.element);
            },
        });
    }

    // ------------------------------------------------------------------------

    // If using tooltip event
    if (!isEmptyObject(config.tooltipEvent)) {
        // Foreach Modal Event
        for (const key of Object.keys(config.tooltipEvent)) {
            const value = config.tooltipEvent[key];

            const type = key + '.bs.tooltip';

            // Create event
            exEvent.create(elements.element, {
                [type]: value,
            });
        }
    }
}

// ----------------------------------------------------------------------------

export { create, settings };
